import { publicRequestsTyped } from "@/api/(requests)/publicTyped";
import type { UUID } from "@/core/types";

export async function getPracticeName(practiceId: UUID): Promise<string> {
  const response = await publicRequestsTyped.get_practice_name({
    context: { showLoader: false },
    practiceId,
  });

  return response.message;
}
